import React from 'react';

import SVGIcon from '@arrive/svg-icon';
import DEAD_END from 'assets/deadend.svg';

import styles from 'components/CPCommittedCapacity/components/EmptyCommitmentsState/EmptyCommitmentsState.scss';

export default function EmptyCommitmentsState({ activeLanesSelected }: { activeLanesSelected: boolean}) {
  return (
    <div className={styles.emptyContainer}>
      <SVGIcon className={styles.deadEndIcon} svgRef={DEAD_END}></SVGIcon>
      <div className={styles.emptyStateHeader}>You have no {activeLanesSelected ? 'active' : 'inactive'} lanes</div>
      {activeLanesSelected && <div className={styles.emptyStateSubText}>Reach out to your carrier rep to make a commitment.</div>}
    </div>
  )
}
